var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWhiteClosedEyeIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 52,
    viewBox: "0 0 51 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25.3846,
    cy: 25.8294,
    r: 25.3846,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 19.2393H11.6667V21.8935H9V19.2393ZM14.3333 24.5477H11.6667V21.8935H14.3333V24.5477ZM19.6667 27.2019V24.5477H14.3333V27.2019H11.6667V29.8562H14.3333V27.2019H19.6667ZM30.3333 27.2019H19.6667V29.8562H17V32.5104H19.6667V29.8562H30.3333V32.5104H33V29.8562H30.3333V27.2019ZM35.6667 24.5477H30.3333V27.2019H35.6667V29.8562H38.3333V27.2019H35.6667V24.5477ZM38.3333 21.8935V24.5477H35.6667V21.8935H38.3333ZM38.3333 21.8935V19.2393H41V21.8935H38.3333Z",
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteClosedEyeIcon);
export default __webpack_public_path__ + "static/media/white-closed-eye-icon.57fa040bb69aa449e8f0dfc5b5f85401.svg";
export { ForwardRef as ReactComponent };